var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66275 0.00145479C4.41676 -0.0907098 0.0910417 4.20785 0.00141565 9.60242C-0.049492 12.6612 1.27626 15.4103 3.38713 17.2384C3.52515 17.1146 3.67322 17.001 3.83777 16.9089L6.67246 15.3188C7.04423 15.1102 7.27583 14.7094 7.27583 14.2737V13.0792C7.27583 13.0792 6.44374 12.0558 6.12646 10.6339C5.86332 10.4588 5.68694 10.1561 5.68694 9.81145V8.50419C5.68694 8.21664 5.81134 7.95968 6.00457 7.77978V5.89003C6.00457 5.89003 5.62707 2.94925 9.49999 2.94925C13.3729 2.94925 12.9954 5.89003 12.9954 5.89003V7.77978C13.189 7.95968 13.313 8.21664 13.313 8.50419V9.81145C13.313 10.2509 13.0262 10.6207 12.6369 10.7442C12.42 11.4376 12.107 12.0986 11.6933 12.6995C11.589 12.851 11.4915 12.9793 11.4062 13.0792V14.3039C11.4062 14.7548 11.6539 15.1673 12.0461 15.3686L15.0815 16.9291C15.2637 17.0228 15.4282 17.1411 15.5799 17.2727C17.6269 15.5172 18.9494 12.8923 18.9986 9.93643C19.0889 4.54185 14.9091 0.0936194 9.66275 0.00145479Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.030e9d8c.svg";
export { ForwardRef as ReactComponent };